<script>
  import { onMount } from "svelte";
  import { fetchENSAddress } from "../util/data-fetcher";
  import { link as routeLink } from "../util/anchor-link.js";
  import { shortAddress } from "../util/shortAddress.js";

  export let link = true;
  export let short = true;
  export let resolve = false;
  export let faded = false;
  export let address = "";
  export let bold = false;
  export let addressAsPlaceholder = true;

  let display;
  $: updateDisplay(address, short);
  // let resolved = address;
  // $: {
  //   resolved = address;
  // }

  onMount(() => {
    return () => {};
  });

  function getAddressDisplay(address, short) {
    return short ? shortAddress(address) : address;
  }

  async function updateDisplay(address, short) {
    // console.log("setting display", address);
    display = addressAsPlaceholder ? getAddressDisplay(address, short) : "...";
    if (address) {
      display = await resolution(address, short);
    }
  }

  async function resolution(address, short) {
    if (!/^0x/i.test(address)) {
      console.log("RESOLVE USER NON-ADDRESS", address);
    }
    const res =
      resolve && /^0x/i.test(address)
        ? await fetchENSAddress({ address })
        : null;
    if (res) return res;
    else return getAddressDisplay(address, short);
  }
</script>

{#if link && address}
  <a
    use:routeLink
    class:faded
    class:bold
    class:short
    alt={address || display}
    href={`/gallery/address/${address}`}>{display}</a
  >
{:else}
  <span class:short class:bold class:faded title={address || display}
    >{display}
  </span>
{/if}

<style>
  a,
  span {
    color: currentColor;
    letter-spacing: 0.03em;
    font-weight: 400;

    /* display: flex; */
    /* max-width: 200px; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 500px;

    --color: currentColor;
    --shadow-color: currentColor;
    color: var(--color);
    margin: 0;
    appearance: none;
    box-sizing: border-box;
    text-decoration: none;
    outline: 0;
  }
  a {
    cursor: pointer;
    border-bottom: 1px solid var(--shadow-color);
  }
  .short {
    max-width: 200px;
  }
  .faded {
  }
  .bold {
    font-weight: bold;
  }
</style>
